export const isBrowser = () => (
  typeof (window) !== 'undefined'
  && window.document !== undefined
)

export const isAndroid = () => (
  isBrowser()
  && /android/i.test(window.navigator.userAgent)
)

/**
 * Нужно будет переписать позже
 */
export const isSafari = () => (
  isBrowser()
  && isApple()
  && /safari/i.test(window.navigator.userAgent)
)

export const isApple = () => (
  isBrowser()
  && /apple/i.test(window.navigator.vendor)
)

export const isYaAndroidBrowser = () => (
  isAndroid()
  && /YaBrowser|Yowser|YaApp_iOS/i.test(window.navigator.userAgent)
)
